import { render, staticRenderFns } from "./SetupPage.vue?vue&type=template&id=8c87d926&"
import script from "./SetupPage.vue?vue&type=script&lang=js&"
export * from "./SetupPage.vue?vue&type=script&lang=js&"
import style0 from "./SetupPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports